<div>
  <ng-container *ngIf="dropdownType === 'jobs'">
    <ng-select
      (change)="changeJobDropdown($event)"
      [items]="jobsBuffer$ | async"
      [closeOnSelect]="true"
      [searchable]="true"
      [trackByFn]="trackByFn"
      [virtualScroll]="true"
      bindLabel="name"
      bindValue="id"
      [loading]="loading"
      appearance="outline"
      placeholder="Select by name or job number"
      [ngModelOptions]="{ standalone: true }"
      (scrollToEnd)="scrollToEnd()"
      [typeahead]="input$"
      (search)="searchJobs($event)"
      [clearable]="true"
      [(ngModel)]="selectedJobs">
      <ng-template ng-label-tmp let-item="item" let-item$="item$"> {{ item.jobNumber }} {{ item.name }} </ng-template>
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <span> {{ item.jobNumber }} {{ item.name }} </span>
      </ng-template>
    </ng-select>
  </ng-container>
  <ng-container *ngIf="dropdownType === 'single'">
    <ng-select
      (change)="changeFn($event)"
      [items]="itemBuffer$ | async"
      [closeOnSelect]="true"
      (close)="refreshDropdown()"
      [searchable]="true"
      [trackByFn]="trackByFn"
      [virtualScroll]="true"
      [loading]="inputLoading"
      [clearable]="true"
      bindLabel="{{ bindLabel }}"
      bindValue="id"
      appearance="outline"
      placeholder="Select {{ label }}"
      (scrollToEnd)="fetchMoreItems()"
      [ngModelOptions]="{ standalone: true }"
      [typeahead]="inputBox$"
      (search)="searchItem($event)"
      [(ngModel)]="selectedItems">
    </ng-select>
  </ng-container>
</div>
